<template>
  <div
    class="messages"
    :style="[
      style.longestHeight,
      style.messagesWrapper,
    ]"
    id="messages"
  >
    <div
      class="messages__wrapper"
      id="messagesWrapper"
      :style="{
        '--loaderDuration': transitionDuration / messages.length + 'ms',
        '--offsetTop': maxSentenceHeight + 'px',
      }"
    >
      <div
        v-for="(message, index) in messages"
        :key="index"
        :id="[
          message === longestSentence ? 'longestSentence' : '',
        ]"
        :class="[
          'messages__message',
          `messages__message--${index}`,
          {
            'active': index === 0,
            'finished': messages.length === 1
          }
        ]"
        :style="heightFetched ? style.message : ''"
      >
        <h2 
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          class="h2 mt0 mb0">{{ message }}</h2>
      </div>
    </div>
  </div>
</template>

<script>
// Vuex
import { mapGetters } from 'vuex';

import { arrayLoop } from 'utils/array';


export default {
  name: 'module-messages',

  props: {
    messages: Array,
  },

  data() {
    return {
      maxSentenceHeight: 0,
      heightFetched: false,
    };
  },

  // Data
  computed: {
    ...mapGetters('app', [
      'appPage',
      'appState',
    ]),
    ...mapGetters('app', ['org']),
    
    longestSentence() {
      let largestSentence = '';

      arrayLoop(this.messages, (index, message) => {
        if (message.length > largestSentence.length) {
          largestSentence = message;
        }
      });
      return largestSentence;
    },

    timePerMessage() {
      return this.transitionDuration / this.messages.length;
    },

    transitionDuration() {
      return this.messages.length === 1 ? 3000 : this.messages.length * 2000;
    },

    style() {
      return {
        longestHeight: {
          height: `${this.maxSentenceHeight}px`,
        },
        messagesWrapper: {
          'overflow-y': 'hidden',
          height: `${this.maxSentenceHeight}px`,
        },
      };
    },
  },

  methods: {
    getMaxSentenceHeight() {
      this.maxSentenceHeight = document.getElementById('longestSentence').clientHeight;
      this.$emit('messages-height', this.maxSentenceHeight );
    },

    addActiveClasses() {

      if(this.messages.length > 1 ) {
        arrayLoop(this.messages, (index) => {

          const current = document.querySelector(`.messages__message--${index}`);
          const previous = document.querySelector(`.messages__message--${index - 1}`);

          const changeClasses = () => {
            previous.classList.remove('active');
            current.classList.add('active');
          };

          if (index >= 1 && index + 1 < this.messages.length && previous.matches('.active')) {
            previous.classList.remove('active');

            setTimeout(changeClasses, 500);

          }

          else if (index + 1 === this.messages.length && previous.matches('.active')) {
            previous.classList.remove('active');

            setTimeout(() => {
              current.classList.add('finished');
            }, 500);
          }
        });
      }
    },

    setupMessages() {
      this.$nextTick(() => {
        this.getMaxSentenceHeight();
        this.heightFetched = true;
        const interval = setInterval(this.addActiveClasses, this.timePerMessage);
        setTimeout(() => {
          clearInterval(interval);
          this.$emit('messages-complete');
        }, this.transitionDuration);
      });
    },
  },

  created() {
    this.setupMessages();
  },
};
</script>



// WEBPACK FOOTER //
// LoaderMessages.vue?59522b44